import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { RoomThumb } from './RoomThumb'
import { useHubLang } from '../lib/i18n'
import { CONTESTS } from '../lib/hubCopy'
import { contestForPost, type Contest } from '../lib/photoContests'
import { nameOf } from './ContestCard'

/**
 * 151 (David, 10 Oct): "congrats auto posted in the feed with congrats to the
 * winners and the photos available in the feed".
 *
 * The post a judge's confirmation writes is an ordinary post with words only —
 * re-attaching the winners' files to a second post would confuse every rule
 * keyed by storage path since 141. So the photos are drawn HERE, under the
 * post, from the contest the post announced (photo_contest_feed). Every card
 * asks; one read answers them all (contestForPost caches for a minute), and a
 * card that announced nothing renders nothing.
 */
export function ContestResults({ contentId }: { contentId: string }) {
  const lang = useHubLang()
  const t = CONTESTS[lang]
  const [c, setC] = useState<Contest | null>(null)
  useEffect(() => {
    let live = true
    contestForPost(contentId)
      .then((x) => live && setC(x))
      .catch(() => undefined)
    return () => {
      live = false
    }
  }, [contentId])
  if (!c || c.winners.length === 0) return null
  const many = c.places.filter((p) => p.award === 'judges').length > 1
  return (
    <section className="contestresults" aria-label={nameOf(c, lang)}>
      <p className="contestresults__eyebrow">{t.feedEyebrow}</p>
      <ul className="contestresults__list">
        {c.winners.map((w) => {
          const place = w.award === 'judges' ? t.judgesAward(w.rank, many) : t.placeName(w.rank)
          const img = <RoomThumb path={w.path} alt={`${place} — ${w.name}`} className="contestresults__img" />
          return (
            <li key={w.place} className="contestresults__item">
              {w.contentId ? (
                <Link className="contestresults__open" to={`/item/${w.contentId}?photo=${encodeURIComponent(w.path)}`}>
                  {img}
                </Link>
              ) : (
                img
              )}
              <span className="contestresults__place">{place}</span>
              <span className="contestresults__name">
                {w.name}
                {w.votes !== null && w.award === 'place' ? ` · ${t.votes(w.votes)}` : ''}
              </span>
            </li>
          )
        })}
      </ul>
      <Link className="btn btn--link btn--sm" to={`/contests/${c.id}`}>
        {t.seeAllPhotos}
      </Link>
    </section>
  )
}
